import { useSyncExternalStore } from "react";

const KEY = "gridiron-season";
const listeners = new Set();

export const getSeasonPick = () => localStorage.getItem(KEY) || "auto";

export function setSeasonPick(value) {
  localStorage.setItem(KEY, value);
  listeners.forEach((l) => l());
}

const subscribe = (l) => {
  listeners.add(l);
  return () => listeners.delete(l);
};

export const useSeasonPick = () => useSyncExternalStore(subscribe, getSeasonPick);
